var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative flex flex-col h-screen"},[_c('Header'),_c('router-view',{staticClass:"flex-1 "})],1)}
var staticRenderFns = []

export { render, staticRenderFns }